import SmoothScroll from 'smooth-scroll'

/**
 * Accordions functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class Accordions {
  /**
   * Constructs a new Accordions instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.accordion = this.element.queryAll('[data-component="accordion"]')
    this.touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 1000,
      speedAsDuration: true,
      updateURL: false,
      header: '[data-component="global-header"]'
    }

    this.accordion.forEach(element => {
      const toggle = element.querySelector('header')
      const accordionDetails = element.querySelector('.accordion-details')
      const closeBtn = element.querySelector('.close-btn button')

      if (closeBtn) {
        closeBtn.addEventListener('click', e => {
          this.close(this.accordion)
          setTimeout(() => { this.scroll.animateScroll(element, element, this.scrollOptions) })
        })
      }

      toggle.addEventListener('click', e => {
        var index = this.accordion.indexOf(element)
        if (element.classList.contains('open')) {
          this.close(this.accordion)
          e.preventDefault()
        } else {
          e.preventDefault()
          this.close(this.accordion)
          this.open(element, index, accordionDetails)
          if (document.body.classList.contains('home') || document.body.classList.contains('page-template-page-faqs-and-resources')) {
            setTimeout(() => { this.scroll.animateScroll(element, element, this.scrollOptions) }, 1000)
          }
        }
      })

    })
  }

  /**
  * Closes expanded state.
  */
  close (question) {
    this.accordion.forEach(element => {
      element.classList.remove('open')
    })
    document.body.classList.remove('accordion-open')
  }

  /**
  * Opens expanded state.
  */
  open (element, index, accordionDetails) {
    element.classList.add('open')
    if (!document.body.classList.contains('page-template-page-what-we-do-php')) {
      document.body.classList.add('accordion-open')
    }
    // document.body.classList.add('scrolling')

  }
}



// WEBPACK FOOTER //
// ./components/accordions/index.js